<template>
  <div class="l_faq">
    <div class="container">
      <div class="head-border">はじめての方へ</div>
      <div class="list-faq flex-column-center">
        <div class="item-faq">
          <router-link
            to="/faq/basic-setting"
            class="flex-justify-center"
            @click.native="
              () => {
                trapTrackEvent(1)
              }
            "
          >
            <img
              :src="require('@/assets/img/faq/setting.svg')"
              alt="ico_setting"
            />
            <div class="description flex-justify-sb-center">
              <p>基本設定</p>
              <img
                :src="require('@/assets/img/faq/silver.png')"
                alt="ico_setting"
              />
            </div>
          </router-link>
        </div>

        <div class="item-faq">
          <router-link
            to="/faq/collect-stamp"
            class="flex-justify-center"
            @click.native="
              () => {
                trapTrackEvent(2)
              }
            "
          >
            <img
              :src="require('@/assets/img/faq/stamp.svg')"
              alt="ico_setting"
            />
            <div class="description flex-justify-sb-center">
              <p>スタンプをためよう</p>
              <img
                :src="require('@/assets/img/faq/silver.png')"
                alt="ico_setting"
              />
            </div>
          </router-link>
        </div>

        <div class="item-faq">
          <router-link
            to="/faq/use-coupon"
            class="flex-justify-center"
            @click.native="
              () => {
                trapTrackEvent(3)
              }
            "
          >
            <img
              :src="require('@/assets/img/faq/coupon.svg')"
              alt="ico_setting"
            />
            <div class="description flex-justify-sb-center">
              <p>クーポンを使ってみよう</p>
              <img
                :src="require('@/assets/img/faq/silver.png')"
                alt="ico_setting"
              />
            </div>
          </router-link>
        </div>

        <div class="item-faq">
          <router-link
            to="/faq/reset-stamp"
            class="flex-justify-center"
            @click.native="
              () => {
                trapTrackEvent(3)
              }
            "
          >
            <img
              :src="require('@/assets/img/faq/reset-stamp.svg')"
              alt="ico_setting"
            />
            <div class="description flex-justify-sb-center">
              <p>スタンプカードリセットについて</p>
              <img
                :src="require('@/assets/img/faq/silver.png')"
                alt="ico_setting"
              />
            </div>
          </router-link>
        </div>

        <div class="item-faq">
          <router-link
            to="/faq/model-change"
            class="flex-justify-center"
            @click.native="
              () => {
                trapTrackEvent(7)
              }
            "
          >
            <img
              :src="require('@/assets/img/faq/model_change.svg')"
              alt="ico_setting"
            />
            <div class="description flex-justify-sb-center">
              <p>機種変更時の手続きについて</p>
              <img
                :src="require('@/assets/img/faq/silver.png')"
                alt="ico_setting"
              />
            </div>
          </router-link>
        </div>
      </div>
     
      <div class="head-border">アカウント設定</div>
      <div class="list-faq flex-column-center">
      
        <template v-if="canSIWA">
          <div class="item-faq">
            <router-link
              to="/siwa"
              class="flex-justify-center"
              @click.native="
                () => {
                  trapTrackEvent(18)
                }
              "
            >
              <img
                :src="require('@/assets/img/faq/siwa-faq-icon.svg')"
                alt="ico_setting"
              />
              <div class="description flex-justify-sb-center">
                <p>Apple IDと連携する</p>
                <img
                  :src="require('@/assets/img/faq/silver.png')"
                  alt="ico_setting"
                />
              </div>
            </router-link>
          </div>
        </template>
        <div class="item-faq">
          <router-link
            to="/faq/account-delete"
            class="flex-justify-center"
            @click.native="
              () => {
                trapTrackEvent(19)
              }
            "
          >
            <img
              :src="require('@/assets/img/faq/faq_account_delete.svg')"
              alt="ico_setting"
            />
            <div class="description flex-justify-sb-center">
              <p>アプリアカウントを削除する</p>
              <img
                :src="require('@/assets/img/faq/silver.png')"
                alt="ico_setting"
              />
            </div>
          </router-link>
        </div>
      </div>
      <div class="head-border">困ったときには</div>

      <div class="search flex-row-wrap">
        <router-link
          to="/faq/stamp"
          class="router"
          @click.native="
            () => {
              trapTrackEvent(4)
            }
          "
        >
          <div class="item-search">
            <img
              :src="require('@/assets/img/faq/stamp-error.svg')"
              alt="ico_setting"
            />
            <p>スタンプが<br />つかない</p>
          </div>
        </router-link>

        <router-link
          to="/faq/read-error"
          class="router"
          @click.native="
            () => {
              trapTrackEvent(5)
            }
          "
        >
          <div class="item-search">
            <img
              :src="require('@/assets/img/faq/error@2x.png')"
              alt="ico_setting"
            />
            <p>読み込みエラー<br />になる場合</p>
          </div>
        </router-link>

        <a
          href="https://www.joyfull.co.jp/joyfull-mobile/#no06"
          class="router"
          @click="
            () => {
              trapTrackEvent(6)
            }
          "
        >
          <div class="item-search">
            <img :src="require('@/assets/img/faq/faq.svg')" alt="ico_setting" />
            <p>よくある<br />ご質問</p>
          </div>
        </a>
      </div>

      <router-link
        to="/faq/inquiry"
        @click.native="
          () => {
            trapTrackEvent(17)
          }
        "
      >
      </router-link>
      <!-- router-link to="/faq/next_android" @click.native="
          () => {
            trapTrackEvent(9)
          }
        ">
      <div id="android">
        【重要】次回アップデートについて
      </div>
    </router-link -->

      <router-link
        to="/faq/inquiry"
        @click.native="
          () => {
            trapTrackEvent(17)
          }
        "
      >
        <div class="footer flex-justify-center">
          <p class="c_mail">アプリに関するお問い合わせ</p>
        </div>
      </router-link>
      <p v-if="showGW" class="gw">
        ※ゴールデンウィーク期間は土・日・祝日が続くため、ご返信に通常よりお時間を頂く場合がございます。<br />
        メールからのお問合せに関しては土・日・祝日も受付をしておりますが、ご返信については通常営業日から順次対応をさせて頂きます。<br />
        お問合せが集中することが想定されますので、ご返信までお時間を頂くことをあらかじめご了承下さいますよう、宜しくお願い致します。<br />
      </p>
      <p class="caption">
        ※土・日・祝日にいただいたお問合せは翌営業日より順次ご連絡いたします。<br />
        ※メール受信制限等を設定されている場合、返信メールが受け取れない場合がございます。
      </p>
      <br />
    </div>
    <VersionCheck
      :msg="
        'LINE アカウント連携機能はアプリバージョン4.2.0以上対応です。<br />最新版のアプリにアップデートしてください。'
      "
      :show="this.versionCheckAlert"
      :on-close="closeVersionCheckAlert"
    />
  </div>
</template>

<script>
import { FactoryTrack } from '../constant/firebase.js'
import { mapActions } from 'vuex'
import DateFormatter from '../utils/DateFormatter.js'
import VersionCheck from './FAQWalkVersionCheck'
import '@/styles/color.css'
export default {
  name: 'FAQ',
  components: { VersionCheck },
  data: function() {
    return {
      userId: '',
      versionCheckAlert: false,
      canSIWA: false
    }
  },
  async created() {
    document.title = 'ヘルプ・お問い合わせ'

    const accTime = new DateFormatter().format(new Date())
    try {
      window.receivedToken = payload => {
        const json = JSON.parse(payload)
        this.userId = json.user_id
        // this.fetchUserData(json.app_token, accTime, json.user_id)
        window.receivedToken = null
      }
      // クーポン一覧と同じなので一旦apiTypeを3に設定する
      this.actionRequestToken({
        apiType: '3',
        acc_time: accTime
      })
    } catch (e) {
      console.log(e)
    }

    await this.actionCanSIWA()
    try {
      window.receivedCanSIWA = payload => {
        console.log('receivedCanSIWA: ', payload)
        this.canSIWA = payload === 'true'
      }
    } catch (e) {
      console.log(e)
    }
  },
  computed: {
    showGW: function() {
      return new Date() < new Date(2020, 4, 8, 18)
    }
  },
  methods: {
    ...mapActions('Native', [
      'actionRequestToken',
      'actionVer4_2',
      'actionCanSIWA'
    ]),
    ...mapActions('Analytics', ['trackEvent']),
    /**
     * Firebaseトラッキングイベント
     * @param {string} id
     */
    trapTrackEvent(id) {
      console.log(id)
      switch (id) {
        case 1:
          this.trackEvent(FactoryTrack.createFAQBasic())
          break
        case 2:
          this.trackEvent(FactoryTrack.createFAQCollectStamp())
          break
        case 3:
          this.trackEvent(FactoryTrack.createFAQUseCoupon())
          break
        case 4:
          this.trackEvent(FactoryTrack.createFAQStamp())
          break
        case 5:
          this.trackEvent(FactoryTrack.createFAQError())
          break
        case 6:
          this.trackEvent(FactoryTrack.createFAQQuestions())
          break
        case 7:
          this.trackEvent(FactoryTrack.createFAQModelChange())
          break
        case 8:
          this.trackEvent(FactoryTrack.createFAQAndroid())
          break
        case 9:
          this.trackEvent(FactoryTrack.createFAQNextAndroid())
          break
        case 10:
          this.trackEvent(FactoryTrack.createFAQPremium())
          break
        case 11:
          this.trackEvent(FactoryTrack.createFAQStampSupport())
          break
        case 12:
          this.trackEvent(FactoryTrack.createFAQLineLogin())
          break
        case 13:
          this.trackEvent(FactoryTrack.createFAQLoginBonus())
          break
        case 14:
          this.trackEvent(FactoryTrack.createFAQiOS())
          break
        case 15:
          this.trackEvent(FactoryTrack.createFAQInvitation())
          break
        case 16:
          this.trackEvent(FactoryTrack.createFAQWalk())
          break
        case 17:
          this.trackEvent(FactoryTrack.createFAQInquiry())
          break
        case 18:
          this.trackEvent(FactoryTrack.createFAQSIWA())
          break
        case 19:
          this.trackEvent(FactoryTrack.createFAQAcountDelete())
          break
        // TODO: 19 は AccountDelete
        case 20:
          this.trackEvent(FactoryTrack.createFAQiOS530())
          break
        case 21:
          this.trackEvent(FactoryTrack.createFAQSealCollection())
          break
      }
    },
    async tapLineLogin() {
      this.trapTrackEvent(12)
      this.versionCheckAlert = await this.actionVer4_2()
      if (this.versionCheckAlert === 0) {
        this.$router.push('/line-login')
      }
    },
    closeVersionCheckAlert() {
      this.trackEvent(FactoryTrack.createVersionCheckClose())
      this.versionCheckAlert = 0
    }
  }
}
</script>

<style lang="scss" scoped>
.l_faq {
  width: 100%;

  p.gw {
    text-align: left;
    margin: 8px 14px;
    font-size: 10px;
    color: var(--accent-color);
  }

  p.caption {
    text-align: left;
    margin: 8px 14px;
    font-size: 10px;
    color: rgb(102, 102, 102);
  }
}

#android,
.sub_menu {
  font-size: 13px;
  color: #602209;
  margin: 20px 0;
  text-decoration: underline;
}

.l_faq .container .title {
  margin: 18px 10px;
}

.l_faq .container .title > p {
  font-family: HiraKakuPro-W6;
  font-size: 19px;
  font-weight: bold;
  line-height: 1;
  color: #602209;
}

.l_faq .container .title > img {
  max-height: 26px;
  padding-right: 9px;
  border-radius: 4px 0px 0px 4px;
}

.l_faq .container .list-faq .item-faq {
  width: 100%;
  padding: 0px 10px 8px 10px;
}

.l_faq .container .list-faq .item-faq img {
  border-radius: 4px 0 0 4px;
}

.l_faq .container .list-faq .item-faq .description {
  width: 100%;
  border-radius: 0px 4px 4px 0px;
  box-shadow: 0 0 1.5px 0 rgba(0, 0, 0, 0.15);
  background-color: #ffffff;
  padding: 10px;
}

.l_faq .container .list-faq .item-faq .description p {
  font-family: HiraKakuPro-W6;
  font-size: 16px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: var(--dark-accent-color);
}

.l_faq .container .search {
  background-color: var(--background-color);
  margin: 0 10px;
}

.l_faq .container .search .router {
  width: 32%;
  background: #ffffff;
  border-radius: 4px;
}

.l_faq .container .search .router .item-search {
  width: 100%;
  background: #ffffff;
  border-radius: 0px 0px 4px 4px;
}

.l_faq .container .search .router .item-search > p {
  font-family: HiraKakuPro-W6;
  font-size: 13px;
  font-weight: bold;
  line-height: 1.3;
  text-align: center;
  color: var(--dark-accent-color);
  padding: 8px 0px;
}

.l_faq .container .search .item-search > img {
  width: 100%;
  border-radius: 4px 4px 0px 0px;
}

.l_faq .container .footer {
  padding: 14px 0;
  margin: 20px 10px 0px 10px;
  background-color: var(--accent-color);
  border-radius: 6px;
}

.l_faq .container .footer > p {
  font-size: 14px;
  font-weight: bold;
  line-height: 1;
  text-align: center;
  color: #ffffff;
}

.flex-column-center {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.flex-justify-center {
  display: flex;
  justify-content: center;
}

.align-items-center {
  align-items: center;
}

.flex-justify-sb-center {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.flex-row-wrap {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

a {
  text-decoration: none;
}

/* 区切り線 */
.head-border {
  display: flex;
  align-items: center;
  margin: 18px 10px;
  font-family: HiraKakuPro-W6;
  font-size: 16px;
  font-weight: bold;
  line-height: 1;
  color: var(--accent-color);
}

.head-border:before,
.head-border:after {
  content: '';
  height: 3px;
  flex-grow: 1;
  background-color: var(--accent-color);
}

.head-border:before {
  margin-right: 1rem;
}

.head-border:after {
  margin-left: 1rem;
}

/* メールアイコン */
.c_mail {
  padding-left: 25px;
  position: relative;
}

.c_mail::before {
  content: '';
  width: 20px;
  height: 20px;
  background: url('../assets/img/mail.svg') no-repeat;
  background-size: cover;
  position: absolute;
  top: -3px;
  left: 0;
}
</style>
